export const useEnv = () => {
	const appUrl = import.meta.env.VITE_BROMONEY_APP_URL;
	const appStoreDownloadUrl = import.meta.env.VITE_BROMONEY_APP_APPSTORE_URL;
	const apkDownloadUrl = import.meta.env.VITE_BROMONEY_APP_APK_URL;
	const contactEmail = import.meta.env.VITE_BROMONEY_APP_CONTACT_EMAIL;
	const partnersUrl = import.meta.env.VITE_BROMONEY_PARTNERS_APP_URL;

	return {
		appUrl,
		appStoreDownloadUrl,
		apkDownloadUrl,
		contactEmail,
		partnersUrl,
	}
}
